import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Portfolio from "@/pages/Portfolio";
import CaseKickz from "@/pages/CaseKickz";
import CaseRarefig from "@/pages/CaseRarefig";
import CasePresent from "@/pages/CasePresent";
import CaseSayso from "@/pages/CaseSayso";
import CustomCursor from "@/components/CustomCursor";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        document
          .getElementById(hash.slice(1))
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "Studio Atelier — UI/UX Designer Portfolio";
  }, []);

  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <CustomCursor />
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/work/kickz" element={<CaseKickz />} />
          <Route path="/work/rarefig" element={<CaseRarefig />} />
          <Route path="/work/the-present" element={<CasePresent />} />
          <Route path="/work/sayso" element={<CaseSayso />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#fbfbfb",
            border: "1px solid #0a0a0a",
            borderRadius: "0px",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
